const state = {
    pageTexts: []
};

const getters = {
    pageTexts: state => {
        return state.pageTexts;
    },
    pageTextByName: state => name => {
        return state.pageTexts.find(element => typeof element === 'object' && element.name === name);
    }
};

const actions = {
    /**
     * Add one page text, replacing existing item as needed.
     *
     * @param {object} commit
     * @param {object} pageText
     */
    add({ commit }, pageText) {
        commit('add', { pageText: pageText, replaceIfExists: true });
    },

    /**
     * Reset the page texts.
     *
     * @param {object} commit
     */
    reset({ commit }) {
        commit('reset');
    }
};

const mutations = {
    /**
     * Add a page text to the order store.
     *
     * @param {object} state
     * @param {object} pageText
     * @param {bool} replaceIfExists
     */
    add(state, { pageText, replaceIfExists }) {
        if (replaceIfExists) {
            const index = state.pageTexts.findIndex(
                element => typeof element === 'object' && element.name === pageText.name
            );

            if (index > -1) {
                state.pageTexts.splice(index, 1);
            }
        }

        state.pageTexts.push(pageText);
    },

    /**
     * Replace the current page texts object with a new object.
     *
     * @param {object} state
     * @param {array} pageTexts
     */
    set(state, pageTexts) {
        state.pageTexts = pageTexts;
    },

    /**
     * Reset the page texts.
     *
     * @param {object} state
     */
    reset(state) {
        state.pageTexts = [];
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
